import { IHttpApi } from '@cian/http-api';

import { Component } from 'react';

import { CommercialCardContext } from '../../CommercialCard/context';

export interface ICallbackModalProps {
  agentPhone: string;
  callFrom?: string;
  callTo?: string;
  close(): void;
  gaLabel: string;
  httpApi: IHttpApi;
  isAvailableToCall?: boolean;
  timezoneText?: string;
  useOldWidget?: boolean;
}

export interface ICallbackModalContainerContext {
  currentSubdomain: string;
  httpApi: IHttpApi;
}

export class CallbackModalContainer extends Component<ICallbackModalProps> {
  public context: ICallbackModalContainerContext;
  private container: HTMLDivElement | null = null;

  public static contextType = CommercialCardContext;

  public constructor(props: ICallbackModalProps) {
    super(props);

    if (document) {
      this.container = document.createElement('div');
      document.body.appendChild(this.container);
    }
  }

  public componentWillUnmount() {
    if (document && this.container) {
      document.body.removeChild(this.container);
    }
  }

  public render() {
    return null;
  }
}
